import { PropsWithChildren, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { AnalyticsDataPageScreenType } from 'src/types/googleAnalyticsEvents';
import { PageContainer } from 'src/containers';
import { pageWithLayout } from 'src/utils/pageWithLayout';
import { getTargetMessages } from 'src/utils/getTargetMessages';
import { PhrasebookPageProps } from '../types/phrasebookPageProps';
import { PhrasebookPageContent } from '../PhrasebookPageContent';
import * as localesWithMessages from './messages';

const PhrasebookPageLayout = ({
  languagePair,
  targetLanguages,
  pageUrlMeta,
  phrasebookEnglishName,
  children,
}: PropsWithChildren<PhrasebookPageProps>) => {
  const intl = useIntl();
  const { targetLanguageLocale } = languagePair;
  const targetMsgs = getTargetMessages(localesWithMessages, targetLanguageLocale);
  const contentMeta = useMemo(
    () => ({
      contentType: AnalyticsDataPageScreenType.phrasebook,
      contentName: phrasebookEnglishName,
      pageTitle: intl.formatMessage(targetMsgs.metaTitle),
      pageDescription: intl.formatMessage(targetMsgs.metaDescription),
    }),
    [intl, phrasebookEnglishName, targetMsgs.metaDescription, targetMsgs.metaTitle],
  );

  return (
    <PageContainer
      data-testid="phrasebookPage"
      languagePair={languagePair}
      targetLanguages={targetLanguages}
      urlMeta={pageUrlMeta}
      contentMeta={contentMeta}
    >
      {children}
    </PageContainer>
  );
};

export const PhrasebookPage = pageWithLayout(PhrasebookPageLayout, PhrasebookPageContent);
